var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { selected: _vm.showSelected }, attrs: { id: "activityList" } },
    [
      [
        _c(
          "div",
          {
            staticClass: "activity",
            class: { read: _vm.notification.reads[0].hasRead > 0 }
          },
          [
            _c("div", {
              staticClass: "dot",
              on: {
                click: function($event) {
                  _vm.toggleRead(_vm.notification)
                }
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "details",
                on: {
                  click: function($event) {
                    _vm.openActivity(_vm.notification)
                  }
                }
              },
              [
                _c("div", { staticClass: "preview" }, [
                  _vm._v(_vm._s(_vm.getPreview(_vm.notification)))
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "icon" },
                  [
                    _c("v-icon", [
                      _vm._v(_vm._s(_vm.getIcon(_vm.notification)))
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "date" }, [
                  _vm._v(
                    _vm._s(
                      _vm._f("dateTimeShorthand")(_vm.notification.created)
                    )
                  )
                ])
              ]
            )
          ]
        )
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-736a9dfd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-736a9dfd","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ActivityList.vue
// module id = 443
// module chunks = 4